// interactive
import './interactive/SmoothScroll';
//import './interactive/NavbarFixed';
import './interactive/NavBar';
import './interactive/HamburgerMenu';
import './interactive/SearchBox';
import './interactive/Accordion';
import './interactive/Tab';
import './interactive/Modal';
import './interactive/Carousel';
import './interactive/Validate';


  